/* eslint no-tabs: "off", indent: "off", no-case-declarations: "off", no-lonely-if: "off" */

import React from "react";
import _ from "underscore";
import { getUserPoolProjects } from "config/getProjectList.js";
import { setCookie } from "lib/helpers/loginHelpers.js";
import { isUserSubscribed, log } from "lib/helpers/helpers.js";

import {
	ATTEMPTING_LOG_IN,
	BACK_TO_LOGIN,
	CHANGE_PASSWORD_ERROR,
	CHANGE_PASSWORD_SUCCESS,
	CLOSE_CHANGE_PASSWORD_MODAL,
	CREATE_ORIGINAL_PASSWORD_ERROR,
	CREATE_ORIGINAL_PASSWORD_SUCCESS,
	FORCE_LOG_OUT,
	FORCE_PASSWORD_UPDATE,
	LOG_IN_ERROR,
	LOG_IN_SUCCESS,
	NOT_LOGGED_IN,
	OPEN_FORGOT_PASSWORD_VIEW,
	OPEN_CHANGE_PASSWORD_MODAL,
	RECEIVE_USER_SUBSCRIPTIONS,
	RECOVER_PASSWORD_ERROR,
	RECOVER_PASSWORD_SUCCESS,
	RESET_DATA,
	RESET_PASSWORD_ERROR,
	RESET_PASSWORD_SUCCESS,
	SET_API,
	SET_BROWSER_TYPE,
	SET_PROJECT,
	SET_TERMS_AND_CONDITIONS_ACCEPTED,
	SIGNED_OUT,
	UPDATE_LOGIN_EMAIL,
	UPDATE_PASSWORD,
	UPDATE_CHANGE_PASSWORD_NEW,
	UPDATE_CHANGE_PASSWORD_OLD,
	UPDATA_LOGIN_VERIFICATION_CODE,
	UPDATE_LOGIN_NEW_PASSWORD,
} from "actions/constants.js";


const initialState = {
	// User profile
	// authState: "",
	authToken: "",
	// Store username/email for user for when they recover their password
	//	This is okay because the Recover Password screen is only accessible after requesting a new one
	stashUsername: "",
	userEmail: "",
	userName: "",
	userPool: [""],
	userData: null, // Whole CognitoUser object. Only used directly for changing password
	api: {}, // API endpoints
	availableProjects: [""],
	currentProject: "",

	// Email subscriptions
	emailSubscriptions: [], // will be an array of Cognito project group strings, just like availableProjects
	subscribedToCurrentProject: false,

	// Try not to use this. Do feature detection whenever possible
	browserType: "", // string: "blink", "chrome", "edge", "ie", "safari", "firefox", "opera", or undefined

	// UI
	changePasswordModalOpen: false,
	changePasswordSuccess: false,
	checkedForExistingUserOnLoad: false,
	codeDeliveryMessage: "",
	createNewPassword: false,
	forceChangePassword: false,
	forgotPassword: false,
	loggedIn: false,
	loginError: false,
	userJustLoggedIn: false,
	validationInProgress: false,
	termsAndConditionsAccepted: false,

	// Spinner logic
	projectSpinner: false,
	currentNumberOfTrends: 0,
	targetNumberOfTrends: 0,

	// Controled inputs
	loginErrorText: "",
	loginInputEmail: "",
	loginInputChangePasswordNew: "",
	loginInputChangePasswordOld: "",
	loginInputPassword: "",
	loginInputVerificationCode: "",
	loginInputNewPassword: "",
};

const login = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case ATTEMPTING_LOG_IN:
			return Object.assign({}, state, {
				loginError: false,
				validationInProgress: true,
			});
		case LOG_IN_SUCCESS: {
			const { user, currentProject } = action;
			// log(["(login.js (reducer) 103) LOG_IN_SUCCESS", currentProject]);

			// setCookie(
			// 	"login",
			// 	user.signInUserSession &&
			// 		user.signInUserSession.accessToken &&
			// 		user.signInUserSession.accessToken.jwtToken
			// );

			// FLAG_ALTERNATE_PROJECT_TITLES

			const userPool = user.signInUserSession && user.signInUserSession.idToken.payload["cognito:groups"];
			const filteredAvailableProjects = getUserPoolProjects(user, userPool);
			const resolvedCurrentProject = filteredAvailableProjects.find((filteredProject) => {
				return filteredProject.id === currentProject;
			});
			const newCurrentProject = resolvedCurrentProject 
				? currentProject
				: (filteredAvailableProjects && filteredAvailableProjects[0]?.id)
					? filteredAvailableProjects[0].id
					: "";

			return Object.assign({}, state, {
				authToken: user.pool && user.pool.clientId,
				checkedForExistingUserOnLoad: true,
				loggedIn: true,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				validationInProgress: false,
				userEmail: user.signInUserSession && user.signInUserSession.idToken.payload.email,
				userData: user,
				userName: user.username,
				userPool,
				currentProject: newCurrentProject,
				availableProjects: filteredAvailableProjects,
			});
		}
		case LOG_IN_ERROR:
			// log(["(login.js (reducer) 138) LOG_IN_ERROR", action]);
			const errorText = action.error.code === "UserNotFoundException" ? "User not found" : action.error.message;
			console.warn("log in error:", action.error.message);

			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: errorText,
				validationInProgress: false,
			});
		case NOT_LOGGED_IN:
			return Object.assign({}, state, {
				checkedForExistingUserOnLoad: true,
				loggedIn: false,
			});
		case FORCE_LOG_OUT:
			return Object.assign({}, state, {
				loggedIn: false,
				authToken: "",
				stashUsername: "",
				userEmail: "",
				userName: "",
				userPool: [""],
				userData: null, 
				availableProjects: [""],
				currentProject: "",
			});
		case RESET_DATA:
			return Object.assign({}, state, {
				api: {},
			});
		case SET_PROJECT:
			// log(["(login.js (reducer) 157) SET_PROJECT", action.project]);
			return Object.assign({}, state, {
				currentProject: action.project,
				projectSpinner: true,
				currentNumberOfTrends: 0,
				subscribedToCurrentProject: !!_.find(state.emailSubscriptions, (proj) => {
					return proj === action.project;
				}),
			});
		case "receiveTrends":
			return Object.assign({}, state, {
				targetNumberOfTrends: action.trends ? action.trends.length : 1,
			});
		case "receiveTimeseries":
			// console.log(
			// 	"currentNumberOfTrends",
			// 	state.currentNumberOfTrends + 1,
			// 	"of",
			// 	state.targetNumberOfTrends
			// );

			return Object.assign({}, state, {
				currentNumberOfTrends: state.currentNumberOfTrends + 1,
				projectSpinner: state.currentNumberOfTrends + 1 < state.targetNumberOfTrends,
			});
		case CREATE_ORIGINAL_PASSWORD_SUCCESS:
			const firstTimeUser = action.userData;
			// setCookie(
			// 	"login",
			// 	firstTimeUser.signInUserSession &&
			// 		firstTimeUser.signInUserSession.accessToken &&
			// 		firstTimeUser.signInUserSession.accessToken.jwtToken
			// );
			return Object.assign({}, state, {
				authToken: firstTimeUser.pool && firstTimeUser.pool.clientId,
				forceChangePassword: false,
				loggedIn: true,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				validationInProgress: false,
				userEmail: firstTimeUser.signInUserSession && firstTimeUser.signInUserSession.idToken.payload.email,
				userData: firstTimeUser,
				userName: firstTimeUser.username,
				userPool: firstTimeUser.signInUserSession && firstTimeUser.signInUserSession.idToken.payload["cognito:groups"],
			});
		case CREATE_ORIGINAL_PASSWORD_ERROR:
			const firstTimeErrorText = action.error.code === "UserNotFoundException" ? "User not found" : action.error.message;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: firstTimeErrorText,
				validationInProgress: false,
			});
		case SIGNED_OUT:
			if (action.error) {
				console.error("signedOut error. login reducer", action.error);
			}
			return Object.assign({}, state, {
				loggedIn: false,
				authToken: "",
				stashUsername: "",
				userEmail: "",
				userName: "",
				userPool: [""],
				userData: null, 
				availableProjects: [""],
				currentProject: "",
				termsAndConditionsAccepted: false,
			});
		// User object is incomplete for these users.
		case FORCE_PASSWORD_UPDATE:
			return Object.assign({}, state, {
				checkedForExistingUserOnLoad: true,
				forceChangePassword: true,
				loginError: false,
				loginErrorText: "",
				loginInputChangePasswordOld: action.userJustLoggedIn ? state.loginInputPassword : "",
				loginInputEmail: "",
				loginInputPassword: "",
				userJustLoggedIn: action.userJustLoggedIn,
				validationInProgress: false,
				userName: action.username,
				userData: action.user,
			});

		case RECOVER_PASSWORD_SUCCESS:
			return Object.assign({}, state, {
				createNewPassword: true,
				codeDeliveryMessage: `Your reset code was delivered to ${action.user.CodeDeliveryDetails.Destination}`,
				forgotPassword: false,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				stashUsername: action.username,
				validationInProgress: false,
			});
		case RECOVER_PASSWORD_ERROR:
			const recoverPasswordErrorText = action.error.code === "UserNotFoundException" ? "User not found" : action.error.message;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: recoverPasswordErrorText,
				validationInProgress: false,
			});
		case RESET_PASSWORD_SUCCESS:
			// User will be logged in at this point
			return Object.assign({}, state, {
				createNewPassword: false,
				codeDeliveryMessage: "",
				forgotPassword: false,
				loggedIn: true,
				loginError: false,
				loginErrorText: "",
				loginInputPassword: "",
				loginInputEmail: "",
				loginInputVerificationCode: "",
				loginInputNewPassword: "",
				stashUsername: "",
				validationInProgress: false,
			});
		case RESET_PASSWORD_ERROR:
			const resetPasswordErrorText =
				action.error.code === "UserNotFoundException" ? "User not found" : action.error.message ? action.error.message : action.error;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: resetPasswordErrorText,
				validationInProgress: false,
			});

		case CHANGE_PASSWORD_SUCCESS:
			// User will be logged in at this point
			return Object.assign({}, state, {
				changePasswordSuccess: true,
				loginError: false,
				loginErrorText: "",
				loginInputChangePasswordNew: "",
				loginInputChangePasswordOld: "",
				validationInProgress: false,
			});
		case CHANGE_PASSWORD_ERROR:
			const changePasswordErrorText =
				action.error.code === "UserNotFoundException" ? "User not found" : action.error.message ? action.error.message : action.error;
			return Object.assign({}, state, {
				loginError: true,
				loginErrorText: changePasswordErrorText,
				validationInProgress: false,
			});

		// ---- Login navigation ----
		case OPEN_FORGOT_PASSWORD_VIEW:
			return Object.assign({}, state, {
				createNewPassword: false,
				loggedIn: false,
				forgotPassword: true,
				loginError: false,
				loginErrorText: "",
			});
		case BACK_TO_LOGIN:
			return Object.assign({}, state, {
				createNewPassword: false,
				forgotPassword: false,
				loginError: false,
				loginErrorText: "",
				loginInputVerificationCode: "",
				loginInputNewPassword: "",
			});
		case OPEN_CHANGE_PASSWORD_MODAL:
			return Object.assign({}, state, {
				changePasswordModalOpen: true,
			});
		case CLOSE_CHANGE_PASSWORD_MODAL:
			return Object.assign({}, state, {
				changePasswordModalOpen: false,
				changePasswordSuccess: false,
				loginError: false,
				loginErrorText: "",
				loginInputChangePasswordNew: "",
				loginInputChangePasswordOld: "",
			});

		// Subscriptions
		case RECEIVE_USER_SUBSCRIPTIONS:
			// console.log(RECEIVE_USER_SUBSCRIPTIONS, action.subscriptions);
			return Object.assign({}, state, {
				emailSubscriptions: action.subscriptions,
				subscribedToCurrentProject: isUserSubscribed({
					currentProject: state.currentProject,
					subscriptions: action.subscriptions,
				}),
			});
		case "subscribeToEmailSuccess":
			return Object.assign({}, state, {
				emailSubscriptions: action.response.lists,
				subscribedToCurrentProject: isUserSubscribed({
					currentProject: state.currentProject,
					subscriptions: action.response.lists,
				}),
			});
		case SET_TERMS_AND_CONDITIONS_ACCEPTED: {
			return {
				...state,
				termsAndConditionsAccepted: action.accepted,
			}
		}

		case SET_API:
		case SET_BROWSER_TYPE:
		case UPDATE_LOGIN_EMAIL:
		case UPDATE_PASSWORD:
		case UPDATA_LOGIN_VERIFICATION_CODE:
		case UPDATE_LOGIN_NEW_PASSWORD:
		case UPDATE_CHANGE_PASSWORD_NEW:
		case UPDATE_CHANGE_PASSWORD_OLD:
			return Object.assign({}, state, payload);

		default:
			return state;
	}
};

export default login;
